import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import LabelItem from '../LabelItem';
import ListItem from '../ListItem';
import { ReactComponent as TaxesIcn } from '../../../../icons/taxes-icon.svg';
import getColorClasses from '../../lib/getColorClasses';

const Taxes = ({ currentPath }) => {
  const { t } = useTranslation('PAGES');
  const validPaths = ['/app/taxes'];

  return (
    <ListItem>
      <Link to="/app/taxes" className="flex">
        <TaxesIcn className={getColorClasses(currentPath, validPaths)} />
        <LabelItem className={getColorClasses(currentPath, validPaths)}>{t('TAX_RATES')}</LabelItem>
      </Link>
    </ListItem>
  );
};

export default Taxes;
